import React from 'react';

const Dashboard = React.lazy(() => import('pages/Dashboard'));

const DashboardRoutes = [
  // dashboard
  {
    path: '/',
    exact: true,
    name: 'Trang chủ',
    any: true,
    function: 'DASHBOARD_VIEW',
    component: Dashboard,
  },
  //Dashboard
  {
    path: '/dashboard',
    exact: true,
    name: 'Trang chủ',
    function: 'DASHBOARD_VIEW',
    any: true,
    component: Dashboard,
  },
  //.end#dashboard
];

export default DashboardRoutes;
